const options = {
  5: "bg-stone-50/5",
  10: "bg-stone-50/10",
  25: "bg-stone-50/25",
  50: "bg-stone-50/50",
  75: "bg-stone-50/75",
  90: "bg-stone-50/90",
  100: "bg-stone-50",
};

const from = {
  5: "from-stone-50/5",
  10: "from-stone-50/10",
  25: "from-stone-50/25",
  50: "from-stone-50/50",
  75: "from-stone-50/75",
  90: "from-stone-50/90",
  100: "from-stone-50",
};

export default function getBackgroundStone50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
